<template>
  <h3 class="text-l md:text-xl xl:text-2xl leading-none font-semibold mb-5" :class="textColor">
    {{ title }}
  </h3>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: false, default: undefined },
  textColor: { type: String, required: false, default: 'text-app-primary-1-red--torch' },
})
</script>
